import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"
import axios from 'axios';
import router from '../router/index'

Vue.use(Vuex);

const state = {
    permission: null,
    role: null,
    base: process.env.BASE_URL,
    api: process.env.VUE_APP_BASE_API,
    client_id: null,
    profile_info: null,
    alias_name: null,
    appKey: "xj91U3mjQUlIYZXofN",
    tokenKey: null,
    authKey: "ADMIN_APP",
    authKeyWeb: "WEB_APP",
    event: null,
    user: null,
};
const getters = {
    isAuthenticated: state => !!state.tokenKey,
    StatePermission: state => state.permission,
    StateApi: state => state.api,
    StateAppKey: state => state.appKey,
    StateTokenKey: state => state.tokenKey,
    StateAuthKey: state => state.authKey,
    StateAuthKeyWeb: state => state.authKeyWeb,
};
const actions = {
    async LogOut({commit}){
        commit('setLogOut')
    },
    async LogIn({commit, getters}, payload) {
        let res = {}
        await axios.post(getters.StateApi + 'admin/v1/code', payload, {headers: {
                'X-Requested-With': "XMLHttpRequest",
                'X-Authorization-Key': getters.StateAuthKey,
                'X-App-Key': getters.StateAppKey,
            }})
            .then(async function (response) {
                console.log("login success" + JSON.stringify(response.data))
                res.status = response.data.data.code
                res.message = response.data.data.message
            })
            .catch(async function (error) {
                console.log('error: ' + JSON.stringify(error.response.data))

                if (error.response.status === 422) {
                    res.message = error.response.data.statusDescription
                }
                else {
                    res.message = error.response.data.data.message
                    res.status = error.response.data.data.code

                    if (res.status === 401 || res.status === 406 || res.status === 500) {
                        commit('setLogOut')
                    }
                }
            })

        return res
    },
    async LogInCode({commit, getters}, payload) {
        let res = {}
        await axios.post(getters.StateApi + 'admin/v1/login', payload, {headers: {
                'X-Requested-With': "XMLHttpRequest",
                'X-Authorization-Key': getters.StateAuthKey,
                'X-App-Key': getters.StateAppKey,
            }})
            .then(async function (response) {
                console.log("login success" + JSON.stringify(response.data))
                // {"code":"Error","statusDescription":"Request is not successfsul","data":{"code":406,"message":"An Error Occured, User status is not verified!"}}
                res.status = response.data.data.code
                res.message = response.data.data.message
                if (res.status === 200) {
                    if (response.data.data.data.token) {
                        await commit('setAuth', response.data.data.data.token)
                        await commit('setPermission', response.data.data.data.permissions)
                        await commit('setRole', response.data.data.data.acl_id)
                        await commit('setProfileInfo', response.data.data.data.profile_info)
                        await commit('setAliasName', response.data.data.data.full_name)
                    }
                }
            })
            .catch(async function (error) {
                console.log('error: ' + JSON.stringify(error.response.data))

                if (error.response.status === 422) {
                    res.message = error.response.data.statusDescription
                }
                else {
                    res.message = error.response.data.data.message
                    res.status = error.response.data.data.code

                    if (res.status === 401 || res.status === 406 || res.status === 500) {
                        commit('setLogOut')
                    }
                }
            })

        return res
    },
    async passwordForgot({commit, getters}, payload) {
        let res = {}
        await axios.post(getters.StateApi + 'admin/v1/reset', payload, {headers: {
                'X-Requested-With': "XMLHttpRequest",
                'X-Authorization-Key': getters.StateAuthKey,
                'X-App-Key': getters.StateAppKey,
            }})
            .then(async function (response) {
                console.log("login success" + JSON.stringify(response.data))
                res.status = response.data.data.code
                res.message = response.data.data.message
            })
            .catch(async function (error) {
                console.log('error: ' + JSON.stringify(error.response.data))

                if (error.response.status === 422) {
                    res.message = error.response.data.statusDescription
                }
                else {
                    res.message = error.response.data.data.message
                    res.status = error.response.data.data.code

                    if (res.status === 401 || res.status === 406 || res.status === 500) {
                        commit('setLogOut')
                    }
                }
            })

        return res
    },
    async passwordReset({commit, getters}, payload) {
        let res = {}
        await axios.post(getters.StateApi + 'admin/v1/verify', payload, {headers: {
                'X-Requested-With': "XMLHttpRequest",
                'X-Authorization-Key': getters.StateAuthKey,
                'X-App-Key': getters.StateAppKey,
            }})
            .then(async function (response) {
                console.log("login success" + JSON.stringify(response.data))
                res.status = response.data.data.code
                res.message = response.data.data.message
            })
            .catch(async function (error) {
                console.log('error: ' + JSON.stringify(error.response.data))

                if (error.response.status === 422) {
                    res.message = error.response.data.statusDescription
                }
                else {
                    res.message = error.response.data.data.message
                    res.status = error.response.data.data.code

                    if (res.status === 401 || res.status === 406 || res.status === 500) {
                        commit('setLogOut')
                    }
                }
            })

        return res
    },

    async getPredictionList({commit, getters}) {
        let res = {}
        await axios.get(getters.StateApi + '?route=predictions/types', {})
            .then(async function (response) {
                //console.log("success: " +JSON.stringify(response))
                res.status = response.status
                res.message = response.data
            })
            .catch(function(error) {
                console.log(JSON.stringify(error))

            })

        return res
    },
    async getPredictionTypeList({commit, getters}, id) {
        let res = {}
        await axios.get(getters.StateApi + '?route=predictions/type/list/' + id, {})
            .then(async function (response) {
                //console.log("success: " +JSON.stringify(response))
                res.status = response.status
                res.message = response.data
            })
            .catch(function(error) {
                console.log(JSON.stringify(error))

            })

        return res
    },
    async getFixtures({commit, getters}, params = null) {
        let res = {}
        let url = new URLSearchParams(params).toString();
        await axios.get(getters.StateApi + '?route=fixtures&' + url, {})
            .then(async function (response) {
                //console.log("success: " +JSON.stringify(response))
                res.status = response.status
                res.message = response.data.data
            })
            .catch(function(error) {
                console.log(JSON.stringify(error))

            })

        return res
    },
    async addPrediction({commit, getters}, payload) {
        let res = {}
        payload.method = 'POST'
        payload.route = 'predictions/create'
        await axios.post(getters.StateApi, payload,{})
            .then(async function (response) {
                console.log("success: " +JSON.stringify(response.data))
                res.status = response.status
                res.message = response.data
            })
            .catch(function(error) {
                console.log(JSON.stringify(error))
                res.status = error.response.status
                res.message = error.response.data
            })

        return res
    },
};
const mutations = {
    setAuth(state, token){
        state.tokenKey = token
    },
    setPermission(state, permission){
        state.permission = permission
    },
    setRole(state, role){
        state.role = role
    },
    setProfileInfo(state, profile_info){
        state.profile_info = profile_info
    },
    setAliasName(state, alias_name){
        state.alias_name = alias_name
    },
    setLogOut(state){
        state.tokenKey = null
        router.push({name: 'login'});
    },
    setUser(state, user){
        state.user = user
    },
};

export default new Vuex.Store({
  state: state,
  mutations: mutations,
  actions: actions,
  getters: getters,
  plugins: [createPersistedState()]
});
